import { nativeApi } from '@web/common/src/utils/nativeApi';
import { Button, Empty } from 'rc-ui-lib';

export function NotFound() {
  const onBack = () => {
    nativeApi.closeWindow();
    window.location.href = '/vhk/credit';
  };
  return (
    <div className="flex justify-center items-center h-full">
      <Empty image="error" description="Sorry, the page you visited does not exist.">
        <Button type="primary" onClick={onBack}>
          Back Home
        </Button>
      </Empty>
    </div>
  );
}
